<script setup>
import { ref } from 'vue'
import axios from "../../axios";
import storeData from "../../store";
const props = defineProps({
  email: {
    type: String,
    default: '',
  },
  name: {
    type: String,
    default: '',
  },
})

const imageUrl = ref('')

const onFileChange = (e) => {
  const file = e.target.files[0]
  if (file) {
    imageUrl.value = URL.createObjectURL(file)
    const form = new FormData();
    form.append('image',file);
    axios.post("api/uploadProfilePicture",form).then((res)=>{
      console.log(res.data);
    })
  }
}
</script>

<template>
  <div class="card card-profile">
  
    <img src="../../assets/img/bg-profile.jpg" alt="Image placeholder" class="card-img-top" />

  
    <div class="row justify-content-center">
      <div class="col-4 col-lg-4 order-lg-2">
        <div class="mt-n4 mt-lg-n6 mb-4 mb-lg-0 position-relative text-center">
        
          <img
            :src="imageUrl || storeData.state.auth?.user?.profile_picture_url"
            class="rounded-circle img-fluid border border-2 border-white"
            alt="Profile"
            style="width: 100px; height: 100px; object-fit: cover;"
          />

       
          <input type="file" ref="fileInput" @change="onFileChange" accept="image/jpeg, image/png, image/jpg, image/webp" style="display: none;" />

          
          <div
            class="edit-icon position-absolute"
            @click="$refs.fileInput.click()"
            
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-pencil" viewBox="0 0 16 16">
  <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325"/>
</svg>
          </div>
        </div>
      </div>
    </div>

    <!-- Name and Email -->
    <div class="card-body pt-0">
      <div class="text-center mt-4">
        <h5>{{ props.name }}</h5>
        <div class="h6 mt-1">
          <p>{{ props.email }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
 .edit-icon {
    bottom: 0;
    right: 10px;
    background: #a35c2e;
    border-radius: 50%;
    padding: 8px;
    cursor: pointer;
    height: 30px;
    width: 30px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
}

</style>
